export default __webpack_public_path__ + "static/media/Information_icon_orange.8a4b2145.svg";